import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { PhoneOutlined, PhoneFilled } from '@ant-design/icons';
import { useNicService } from 'stores/nic/useNicService';
import { selectCalls, useCallStore } from 'stores/nic/stores/callStore';
import { OutboundView, PhoneIcon, CancelButton } from './styled';
var OutboundCall = function (_a) {
    var callIndex = _a.callIndex;
    var endCall = useNicService().endCall;
    var calls = useCallStore(selectCalls);
    var callState = calls[callIndex];
    var memberToCall = callState === null || callState === void 0 ? void 0 : callState.memberInfo;
    var agentToCall = callState === null || callState === void 0 ? void 0 : callState.agentInfo;
    var phone;
    var name;
    if (memberToCall) {
        phone = memberToCall === null || memberToCall === void 0 ? void 0 : memberToCall.preferred_phone_number;
    }
    if (agentToCall) {
        name = "".concat(agentToCall === null || agentToCall === void 0 ? void 0 : agentToCall.firstName, " ").concat(agentToCall === null || agentToCall === void 0 ? void 0 : agentToCall.lastName);
    }
    return (_jsxs(OutboundView, { children: [_jsx(PhoneIcon, { children: _jsx(PhoneFilled, { rotate: 90, style: { fontSize: 20 } }) }), phone && _jsx("span", { children: "Calling ".concat(phone, " ...") }), name && _jsx("span", { children: "Calling ".concat(name, " ...") }), _jsxs(CancelButton, { onClick: function () { return endCall(callIndex); }, children: [_jsx(PhoneOutlined, { rotate: 225 }), _jsx("span", { children: "Cancel" })] })] }));
};
export default OutboundCall;
